import {
  Block,
  InfoCircle,
  LabelMedium,
  ModalBody,
  ParagraphSmall,
} from "@mezo-org/mezo-clay"

import { ComponentStepProps } from "#/ui/Modal"

import { useAddLiquidityFlowContext } from "../AddLiquidityFlowContext"

import AddLiquidityForm, { OnSubmitAddLiquidityForm } from "./AddLiquidityForm"
import SelectedPool from "./SelectedPool"

export default function AddLiquidityFormStep({
  onClickContinue,
}: ComponentStepProps) {
  const { poolId, setToken1Amount, setToken2Amount } =
    useAddLiquidityFlowContext()

  const onSubmitForm: OnSubmitAddLiquidityForm = (values) => {
    setToken1Amount(values.token1Amount)
    setToken2Amount(values.token2Amount)

    onClickContinue()
  }

  return (
    <ModalBody
      $style={() => ({
        display: "flex",
        flexDirection: "column",
        height: "100%",
      })}
    >
      <Block
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="scale300"
      >
        <LabelMedium>Selected pool</LabelMedium>
        <Block display="flex" marginLeft="auto" alignItems="center">
          <ParagraphSmall marginRight="scale100">50/50 pool</ParagraphSmall>
          {/* TODO: Add tooltip here */}
          {/* TODO: Improve the `InfoCircle` icon - allow to set border, background color */}
          <InfoCircle size={16} />
        </Block>
      </Block>
      {/* TODO: We should fetch the pool data based on the pool id */}
      <SelectedPool poolName={poolId!} tvl="$2.31M" rewards="1,144" />
      <AddLiquidityForm
        token1Balance="1"
        token2Balance="100"
        onSubmitForm={onSubmitForm}
      />
    </ModalBody>
  )
}
